"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreteStripeCustomerAccountDto = void 0;
class CreteStripeCustomerAccountDto {
    accountNumber;
    ip;
    currency;
    routingNumber;
    webpage;
}
exports.CreteStripeCustomerAccountDto = CreteStripeCustomerAccountDto;
